// Client Marquee Section Component
import React from "react";
import client1 from "../assets/images/clients/client-1.png";
import client2 from "../assets/images/clients/client-2.png";
import client3 from "../assets/images/clients/client-3.png";
import client4 from "../assets/images/clients/client-4.png";
import client5 from "../assets/images/clients/client-5.png";
import client6 from "../assets/images/clients/client-6.png";
import client7 from "../assets/images/clients/client-7.png";
import client8 from "../assets/images/clients/client-8.png";
import client9 from "../assets/images/clients/client-9.png";
import client10 from "../assets/images/clients/client-10.png";

const ClientsMarquee = () => {
  const clients = [
    client1,
    client2,
    client3,
    client4,
    client5,
    client6,
    client7,
    client8,
    client9,
    client10,
  ];

  return (
    <section className="clients-marquee py-5 bg-light">
      <div className="container">
        <h2 className="display-7 text-center mb-4 fw-bold">
          Our Valuable Clients
        </h2>
        <div className="marquee-wrapper overflow-hidden">
          <div className="marquee-content d-flex align-items-center">
            {/* First set of logos */}
            {clients.map((client, index) => (
              <img
                key={`first-${index}`}
                src={client}
                alt={`Client ${index + 1}`}
                className="mx-4 client-logo flex-shrink-0"
                style={{
                  height: "60px",
                  width: "auto",
                  maxWidth: "150px",
                  objectFit: "contain",
                  transition: "filter 0.3s ease",
                }}
              />
            ))}
            {/* Duplicate set for seamless loop */}
            {clients.map((client, index) => (
              <img
                key={`second-${index}`}
                src={client}
                alt={`Client ${index + 1}`}
                className="mx-4 client-logo flex-shrink-0"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ClientsMarquee;
